import React from 'react';
import './contest.less';

import rocket from '../../../assets/img/dashboard/contest/rocket.svg';
import gift from '../../../assets/img/dashboard/contest/gift.svg';

const TARGET_COUNT = 300;

export default function Contest({ intl, count = 0 }) {
	const percent = ((count > TARGET_COUNT ? TARGET_COUNT : count) / TARGET_COUNT) * 100;

	return (
		<div className='contest'>
			<div className='contest-header'>
				<div
					dangerouslySetInnerHTML={{
						__html: intl('конкурс продлится с 21 ноября по 21 декабря!')
					}}
				/>
				<div>
					{intl('успей забрать свой профит!')}
				</div>
			</div>
			<div className='contest-main'>
				<div
					className='contest-track'
					style={{ width: `${percent}%` }}
				/>
				<div className='contest-grid'>
					{Array.from({ length: 10 }, (_, i) => <div key={i} />)}
				</div>
				{percent <= 93.5 && (
					<img
						className='contest-rocket'
						style={{
							transform: percent > 2.3 ? 'translateX(-43%)' : undefined,
							left: percent > 2.3 ? `${percent}%` : undefined
						}}
						src={rocket}
					/>
				)}
				<img className='contest-gift' src={gift} />
			</div>
			<div className='contest-footer'>
				{intl('сделано %s / %s апрувов', count, TARGET_COUNT)}
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/dashboard/components/contest.js